import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { HISTORY_TYPE } from '../type/types';

interface postOrderRejectProps {
  orderId: string;
  reason: string;
}

// 주문 접수 거부
export const postOrderReject = async (data: postOrderRejectProps) => {
  const res = await api.post<ApiResponseType<HISTORY_TYPE>>(
    '/api/web/partners/orders/reject',
    data
  );
  return res.data;
};
